import React from 'react';

export default function Asterisk() {
    return <span className="text-red-500 ml-1">*</span>;
}
